import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, Check } from 'lucide-react';

const ProUpgradeCard = ({ feature, message }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-16" style={{ background: 'linear-gradient(135deg,#0A0E27,#050816)' }}>
      <div className="glass-card p-8 max-w-md w-full text-center" data-testid="pro-upgrade-card">
        <div className="w-14 h-14 mx-auto mb-4 rounded-2xl flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg,#fbbf24,#f59e0b)', boxShadow: '0 6px 28px rgba(251,191,36,0.35)' }}>
          <Crown size={24} color="#0A0E27" />
        </div>
        <h2 className="heading-font text-xl font-bold text-white mb-2">{feature} is a Pro feature</h2>
        <p className="text-sm text-gray-400 mb-5" data-testid="pro-upgrade-message">{message}</p>
        <ul className="text-left text-sm text-gray-300 space-y-2 mb-6 inline-block">
          {['Unlimited tasks every week', 'Non-Negotiables (protected time)', 'Schedule Health & burnout insights', 'Monthly Life Intelligence reports'].map(f => (
            <li key={f} className="flex items-center gap-2"><Check size={14} className="text-amber-300" /> {f}</li>
          ))}
        </ul>
        <button onClick={() => navigate('/settings')} data-testid="pro-upgrade-btn"
          className="w-full py-2.5 rounded-xl text-sm font-semibold text-[#0A0E27] transition-transform hover:scale-[1.02]"
          style={{ background: 'linear-gradient(135deg,#fbbf24,#f59e0b)' }}>
          Upgrade to Pro · $5/month
        </button>
      </div>
    </div>
  );
};

export default ProUpgradeCard;
